<script setup lang="ts">
import Tag from 'primevue/tag';
import type { Temperature, ViewFormat } from '@apparatix/types/Leads';

interface LeadStatusChipProps {
  temperature: Temperature;
  view: ViewFormat;
}

defineProps<LeadStatusChipProps>();
</script>
<template>
  <Tag
    v-if="view === 'table'"
    :style="{background: temperature.color}"
    class="!text-white uppercase"
    :value="temperature.temperature"
  />
  <div v-else class="label-bar" :style="{background: temperature.color}" />
</template>

<style scoped>
.label-bar {
  border-radius: 999px;
  width: 36px;
  height: 8px;
  display: block;
}
</style>
